import { FiChevronLeft, FiChevronRight, FiSkipBack, FiSkipForward } from "react-icons/fi";

const Pagination = ({ 
  currentPage, 
  totalPages, 
  onPageChange 
}) => {
  // Calculate page numbers to display (same logic you had)
  const pageNumbers = [];
  const maxVisiblePages = 5;
  let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
  let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

  // Adjust if we're at the beginning or end
  if (endPage - startPage + 1 < maxVisiblePages) {
    startPage = Math.max(1, endPage - maxVisiblePages + 1);
  }

  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  return (
    <div className="pagination center">
        <button 
          onClick={() => onPageChange(1)} 
          disabled={currentPage === 1}
          className="buttonBorder"
        >
          <FiSkipForward />
        </button>
      
        <button 
          onClick={() => onPageChange(currentPage - 1)} 
          disabled={currentPage === 1}
          className="buttonBorder"
        >
          <FiChevronRight />
        </button>
      
        {startPage > 1 && <span>...</span>}
        
        {pageNumbers.map(number => (
          <button
            key={number}
            onClick={() => onPageChange(number)}
            className={`buttonBorder ${currentPage === number ? 'active' : ''}`}
          >
            {number}
          </button>
        ))}
        
        {endPage < totalPages && <span>...</span>}
        
        <button 
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="buttonBorder"
        >
          <FiChevronLeft />
        </button>
        
        <button 
          onClick={() => onPageChange(totalPages)}
          disabled={currentPage === totalPages}
          className="buttonBorder"
        >
          <FiSkipBack />
        </button>
    </div>
  );
};

export default Pagination;
